/* Copyright (c) 2018-2024, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { GdprLevel, Personalization } from '../models/common-data.models';

export class TelemetryEvent<T> {
    readonly name: string;
    readonly gdprLevel: GdprLevel;
    personalization?: Personalization;
    readonly ts;
    parameters: T;
    constructor(info: T) {
        this.parameters = info;
        this.ts = new Date().toISOString();
    }
}
